<template>
  <div class="laporan" :class="{ 'animate-flicker': loading }">
    <div>
      <div class="navbar">
        <div @click="$router.go(-1)">
          <back />
        </div>
        <h2>Laporan Penjualan Detail</h2>
      </div>

      <br />

      <div class="master">
        <table class="table-inline">
          <tr>
            <td>No Nota</td>
            <td>{{ data.no_nota }}</td>
          </tr>
          <tr>
            <td>Waktu Transaksi</td>
            <td>
              {{ moment(data.tanggal).format("DD MMM YYYY HH:mm") }}
            </td>
          </tr>
          <tr>
            <td>Meja</td>
            <td>{{ data.no_meja || "Tanpa Meja" }}</td>
          </tr>
          <tr>
            <td>Customer</td>
            <td>{{ data.tamu || "Tidak diinput" }}</td>
          </tr>
          <tr v-show="data.ojek_online">
            <td>Ojek Online</td>
            <td>{{ data.ojek_online }}, PIN: {{ data.pin }}</td>
          </tr>
        </table>
        <div class="notif" v-if="data.alasan_cancel">
          <p>Transaksi dibatalkan dengan alasan :</p>
          <h3>
            <small>{{ data.penjualan.alasan_batal }}</small>
          </h3>
        </div>
      </div>

      <div class="detail">
        <p>Detail Item</p>

        <table class="table">
          <thead>
            <tr>
              <th>No</th>
              <th>Menu</th>
              <th>Catatan</th>
              <th>Harga Produksi</th>
              <th v-show="data.ojek_online || data.pin">Harga Asli</th>
              <th>Harga Jual</th>
              <th>Jumlah</th>
              <th>Subtotal</th>
              <th>Margin</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in data.detail"
              v-show="item.jumlah > 0"
              :key="index"
            >
              <td>{{ ++index }}</td>
              <td>{{ item.nama }}</td>
              <td>{{ item.catatan || "-" }}</td>
              <td>Rp {{ item.harga_produksi | number }}</td>
              <td v-show="data.ojek_online || data.pin">
                Rp {{ item.harga_asli | number }}
              </td>
              <td>Rp {{ item.harga | number }}</td>
              <td>{{ item.jumlah | number }}</td>
              <td>Rp {{ (item.jumlah * item.harga) | number }}</td>
              <td>
                Rp
                {{
                  ((item.harga - item.harga_produksi) * item.jumlah) | number
                }}
              </td>
            </tr>
            <!-- <tr class="total">
              <td colspan="5">Total</td>
              <td>{{ totalItem | number }}</td>
              <td>Rp {{ subtotalPenjualan | number }}</td>
              <td>Rp {{ subtotalLaba | number }}</td>
            </tr> -->
          </tbody>
        </table>

        <p>Total</p>
        <table class="table-inline">
          <tr>
            <td>Subtotal</td>
            <td align="right">Rp {{ data.sub_total | number }}</td>
          </tr>
          <tr>
            <td>Diskon</td>
            <td align="right">Rp {{ data.jumlah_diskon | number }}</td>
          </tr>
          <tr>
            <td>Pajak</td>
            <td align="right">Rp {{ data.pajak | number }}</td>
          </tr>
          <tr>
            <td>Pembulatan</td>
            <td align="right">
              Rp {{ (data.pembulatan_atas + data.pembulatan_bawah) | number }}
            </td>
          </tr>
          <tr>
            <td>Grand Total</td>
            <td align="right">
              <div style="display: flex; justify-content: space-between">
                <span class="badge-green" style="margin-right: 20px">{{
                  data.tipe_pembayaran || "-"
                }}</span>
                <span> Rp {{ data.grand_total | number }} </span>
              </div>
            </td>
          </tr>
          <tr v-show="data.ojek_online || data.pin">
            <td>Komisi {{ data.ojek_online }} ({{ data.komisi }} %)</td>
            <td align="right">
              Rp {{ ((data.komisi / 100) * data.grand_total) | number }}
            </td>
          </tr>
          <tr>
            <td>Margin</td>
            <td align="right">Rp {{ calculateMargin | number }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import Back from "./../../components/icons/Back.vue";
import * as api from "../../api/Api";
import moment from "moment";

export default {
  name: "Home",
  components: {
    Back,
  },
  data() {
    return {
      loading: false,
      data: {
        detail: [],
      },
      totalItem: 0,
      subtotalPenjualan: 0,
      subtotalLaba: 0,
    };
  },
  computed: {
    calculateMargin() {
      let margin = 0;
      this.data.detail.forEach((item) => {
        margin +=
          (parseInt(item.harga) - parseInt(item.harga_produksi)) *
          parseInt(item.jumlah);
      });

      const margin_kotor =
        margin -
        parseInt(this.data.jumlah_diskon) +
        parseInt(this.data.pajak) +
        parseInt(this.data.pembulatan_atas) +
        parseInt(this.data.pembulatan_bawah);

      if (this.data.ojek_online || this.data.pin) {
        const komisi = (this.data.komisi / 100) * this.data.grand_total;
        return margin_kotor - komisi;
      } else {
        return margin_kotor;
      }
    },
  },
  methods: {
    moment,
    loadData() {
      this.loading = true;
      api
        .get(
          "/v4/laporan/penjualan?guid=" +
            this.$route.params.id +
            "&id_toko=" +
            this.$toko.id
        )
        .then((r) => {
          this.loading = false;
          this.data = r.data;
        })
        .catch((e) => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>

<style scoped lang="scss">
.laporan {
  > div {
    margin: 20px;
  }

  .navbar {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    > div {
      cursor: pointer;
      padding-top: 4px;
    }
  }
  h2 {
    margin: 0;
    margin-left: 15px;
  }

  .table-inline {
    font-size: 15px;
    border-collapse: collapse;
    tr {
      td {
        border: 1px solid #ccc;
        min-width: 130px;
        padding: 10px;
      }
      td:first-child {
        padding-right: 30px;
        background: #eee;
      }
      td:nth-child(2) {
        font-weight: bold;
      }
    }
  }

  .master {
    margin-bottom: 30px;
    position: relative;
  }

  .detail {
    p {
      color: var(--primary);
      font-weight: 600;
      margin: 30px 0px 20px;
    }

    .table {
      .total {
        td {
          border-top: 2px solid #ccc;
        }
      }
    }
  }

  .notif {
    border: 1px solid #ccc;
    padding: 15px;
    border-radius: 4px;
    position: absolute;
    top: 0px;
    left: 350px;
    p {
      margin: 0;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/laporan/PenjualanDetail.vue